/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { structuralClone, toQueryString } from '../../api-helpers';

export interface GetInternalFaqEntryGetSearchStatisticsCsvQueryParams {
  from?: Date;
  to?: Date;
}

export interface GetInternalFaqEntryGetSearchStatisticsCsvParams {
  query: GetInternalFaqEntryGetSearchStatisticsCsvQueryParams;
}

export function httpGetInternalFaqEntryGetSearchStatisticsCsv(http: HttpClient, data: GetInternalFaqEntryGetSearchStatisticsCsvParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<Blob>;
export function httpGetInternalFaqEntryGetSearchStatisticsCsv(http: HttpClient, data: GetInternalFaqEntryGetSearchStatisticsCsvParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<Blob>>;
export function httpGetInternalFaqEntryGetSearchStatisticsCsv(http: HttpClient, data: GetInternalFaqEntryGetSearchStatisticsCsvParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return structuralClone(data).pipe(
    switchMap((dataClone) => {
      return http.get(`{placeholder}/InternalFaqEntry/GetSearchStatisticsCsv?${toQueryString(dataClone.query)}`, { ...options, responseType: 'blob' } as any);
    })
  );
};

export const urlGetInternalFaqEntryGetSearchStatisticsCsv = (baseUrl: string, data: GetInternalFaqEntryGetSearchStatisticsCsvParams) => {
  return `${baseUrl}/InternalFaqEntry/GetSearchStatisticsCsv?${toQueryString(data.query)}`;
};
